
import { authHeader } from '../_helpers';
import { CONST } from '../_config';

export const jobService = {
    login,
    logout,
    addJob,
    uploadImage,
    getJobList,
    disableJob,
    updateJob,
    deleteJob,
    getAllJob,
    createInvoiceDetails,
    getMaterialDetailsByJobId,
    updateMaterialUsed,
    createMaterialUsedAdmin
};



function getMaterialDetailsByJobId(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL2 + `/getMaterialDetailsByJobId`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let jobObj = {
                getJobList: data.data
            }
            return jobObj;
        });
}



function updateMaterialUsed(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL2 + `/updateMaterialUsed`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let jobObj = {
                getJobList: data.data
            }
            return jobObj;
        });
}

function createInvoiceDetails(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL2 + `/createInvoiceDetails`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let jobObj = {
                getJobList: data.data
            }
            return jobObj;
        });
}


function createMaterialUsedAdmin(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL2 + `/createMaterialUsedAdmin`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let jobObj = {
                getJobList: data.data
            }
            return jobObj;
        });
}


function logout() {
    localStorage.removeItem('job');
}
function login(data) {

    let header = new Headers({
            'Content-Type': 'application/json',
            "Authorization": authHeader().Authorization
        });
        const requestOptions = {
            method: "POST",
            headers: header,
            body: JSON.stringify(data)
        }
        return fetch(CONST.BACKEND_URL + `/adminlogin`, requestOptions)
            .then(handleResponse)
            .then(job => {
                let jobObj = {
                    jobinfo: job.data
                }
                if (job.data) {
                    localStorage.setItem('job', JSON.stringify(job.data));
                }
                
                return jobObj;
            });
}
function getJobList(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getJobList`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let jobObj = {
                getJobList: data.data
            }
            console.log("jobObjjobObjjobObj",jobObj);
            
            return jobObj;
        });
}
function getAllJob() {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header
    }
    return fetch(CONST.BACKEND_URL + `/getAllUser`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let jobObj = {
                getAllJob: data.data
            }
            console.log();
            
            return jobObj;
        });
}
function addJob(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/createJob`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let jobObj = {
                addJob: data.data
            }
            console.log();
            
            return jobObj;
        });
}
function updateJob(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateJob`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let jobObj = {
                addJob: data.data
            }
            return jobObj;
        });
}
function disableJob(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/changeState`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let jobObj = {
                addJob: data.data
            }
            console.log();
            
            return jobObj;
        });
}
function deleteJob(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/deleteJob`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let jobObj = {
                addJob: data.data
            }
            console.log();
            
            return jobObj;
        });
}
function uploadImage(filedata) {

    let header = new Headers({
        "Authorization": authHeader().Authorization
    });
    var data = new FormData();
    data.append('image', filedata);

    const requestOptions = {
        method: "POST",
        headers: header,
        body: data
    }
    return fetch(CONST.BACKEND_URL + `/uploadFile`, requestOptions)
        .then(handleResponse)
        .then(res => {
            let jobObj = {
                filesDetails: res.data
            }
            return jobObj;
        });
}
function handleResponse(response) {
   // console.log("response22222   ", response);

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                //location.reload(true);
            }
            console.log("datadatadata ", response);

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        //console.log("datadatadatadatadata   ", data.error);
        if (data.error) {
            console.log("datadatadatadatadata   ", data);
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}